import { render, staticRenderFns } from "./ClassOptionalLikeDislike.vue?vue&type=template&id=3bf4c744&"
import script from "./ClassOptionalLikeDislike.vue?vue&type=script&lang=ts&"
export * from "./ClassOptionalLikeDislike.vue?vue&type=script&lang=ts&"
import style0 from "./ClassOptionalLikeDislike.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports